import storage from '@/services/storage';
import { constants } from '@/shared/constants';

declare global {
  interface Window {
    dataLayer: any
  }
}

export default {
	// Login and Registration
	onLoginSuccess() {
		this.dataLayer({
			event: 'login_success'
		});
	},
	onLoginRememberMe() {
		this.dataLayer({
			event: 'login',
			remember_me: 'true'
		});
	},
	onRegistrationStart() {
		this.dataLayer({
			event: 'register_clicks',
		});
	},
	onTypeRegistrationStart(type: string) {
		this.dataLayer({
			event: 'register_clicks',
			flow: type,
		});
	},
	onTypeRegistrationSuccess(type: string) {
		this.dataLayer({
			event: 'registration_success',
			flow: type,
		});
	},
	onLoginFromRegistration() {
		this.dataLayer({
			event: 'login_from_registration'
		});
	},
	onRegisterNewAccount() {
		this.dataLayer({
			event: 'register_to_new_account'
		});
	},
	// common events
	onBannerClick(type: string) {
		this.dataLayer({
			event: 'banner_click',
			type,
			category: window.location.href,
			unique_user_id: storage.getItem(constants.storage.user).uid,
		});
	},
	onAddonActivation(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'add_on_activation',
			flow: data.flow,
			type: data.type,
			name: data.name,
			amount: data.amount,
			position: data.position,
		});
	},
	onAddonDeactivation(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'add_on_deactivation',
			flow: data.flow,
			type: data.type,
			name: data.name,
			amount: data.amount,
		});
	},
	onChangeTariff(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'tariff_change',
			flow: data.flow,
			name: data.name,
		});
	},
	onMbonClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'mbon',
		});
	},
	onPrepaidTopupSuccess() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			type: 'Zaduzenje racuna',
			automatic_topup: false,
			event: 'prepaid_topup_success'
		});
	},
	onPostpaidTopupSuccess(data: { [key: string]: string | number | boolean }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			type: 'Podeli dopunu',
			automatic_topup: data.automatic,
			event: 'postpaid_topup_success'
		});
	},
	onDearestNumberActivation(flow: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'dearest_number',
			flow: flow
		});
	},
	onFavouriteNumberActivation(flow: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'favourite_number',
			flow: flow
		});
	},
	onFriendNumberActivation(flow: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'friend_number',
			flow: flow
		});
	},
	onFriendNumberEdit(flow: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'friend_number_change',
			flow: flow
		});
	},
	onActivateAdditionalService(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'additional_services_activation',
			flow: data.flow,
			name: data.name,
		});
	},
	onDeactivateAdditionalService(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'additional_services_deactivation',
			flow: data.flow,
			name: data.name,
		});
	},
	// TV
	onChannelClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'genre_clicks',
		});
	},
	onTvToGOCreatedAccount() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'tv_to_go',
		});
	},
	onSTBDeviceAdded() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'stb_adding',
		});
	},
	onSTBDeviceRemoved() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'stb_removing',
		});
	},
	// Parking
	onParkingClick(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'parking',
			city: data.city,
			zone: data.zone,
			value: data.value,
		});
	},
	onGraceActivation(flow: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'grace_activation',
			flow,
		});
	},
	onTariffPlanActivated(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'tariff_plan_activation',
			flow: data.flow,
			type: data.type,
			name: data.name,
			amount: data.amount,
			position: data.position,
		});
	},
	onTariffPlanDeactivated(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'tariff_plan_deactivation',
			flow: data.flow,
			type: data.type,
			name: data.name,
			amount: data.amount,
		});
	},
	// BILLS
	// Pregled računa
	onPDFDownload() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'pdf_dowloads',
			flow: 'Svi racuni'
		});
	},
	onSendBillToEmail() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'email_bill',
		});
	},
	onPayBillClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user)?.uid,
			event: 'pay_bill_clicks',
		});
	},
	// Moj račun
	onEBillActivation() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'ebill_activation',
		});
	},
	onEBillDeactivation() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'ebill_deactivation',
		});
	},
	// Uključenje na riječ
	onServiceActivate(type: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'service_inclusion',
			type: type
		});
	},
	// Plati kao drugo lice
	onPayBillOthers(type: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'service_inclusion',
			type: type
		});
	},
	// APPLICATIONS
	// addon changed
	onApplicationArenaChanged(data: { [key: string]: string | number }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			flow: 'Applications',
			event: 'arena_changed',
			type: data.type,
			name: data.name,
			amount: data.amount,
			position: data.position,
		});
	},
	// SUPPORT
	onSubmitSupportRequest(request: { [key: string]: string }) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: request.event,
			type: request.type,
			name: request.name,
		});
	},
	// NOTIFICATIONS
	onNotificationsOpened() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'notifications_opened',
		});
	},
	onNotificationViewed(name: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			name: name,
			event: 'notifications_viewed',
		});
	},
	onNotificationDeleted(name: string) {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			name: name,
			event: 'notifications_deleted',
		});
	},
	// PROFILE
	onRemoveServiceClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'services_removed',
		});
	},
	onRemoveAccountClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'accounts_deleted',
		});
	},
	// ALTERNATIVE SCENARIOS
	onDeactivatedServiceClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'pay_bill_click',
		});
	},
	onFixedTemporaryDeactivatedServiceClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'nearest_shop_click',
		});
	},
	onFixedOccasionallyDeactivatedServiceClick() {
		this.dataLayer({
			unique_user_id: storage.getItem(constants.storage.user).uid,
			event: 'periodicall_use_click',
		});
	},
	dataLayer(event: object) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(event);
	}
};
